import { axios, getResponse, settings } from '../../helpers/main';

const { backend } = settings;
const objectService = getResponse({ type: 0 }); // eslint-disable-line

/**
 * Service to manage communication with the Accounts API.
 * Follows the Single Responsibility Principle (SRP) by separating network logic from the UI.
 */
export const RequestAccountService = {
    /**
     * Submits a request for a new account.
     * @param {Object} params - Parameters.
     * @param {Object} params.dataForm - Account request data.
     * @param {string} [params.subMethod=''] - Sub-method name for error traceability.
     * @returns {Promise<objectService>} Promise with the API response.
     */
    requestAccountAsync: async ({
        dataForm, subMethod = ''
    } = {}) => {
        const requestObj = {
            url: `${backend?.urls?.api}${backend?.urls?.apiV1}${backend?.urls?.accounts}${backend?.urls?.requestAccount}/`,
            headers: {},
            data: dataForm,
            subMethod: subMethod,
        };
        return await axios.post(requestObj);
    },

    /**
     * Gets account request details by ID.
     * @param {Object} params
     * @param {number} params.id
     * @param {number} params.languageId
     * @param {string} [params.subMethod='']
     * @returns {Promise<objectService>}
     */
    getById: async ({
        id,
        languageId,
        subMethod = ''
    } = {}) => {
        const requestObj = {
            url: `${backend?.urls?.api}${backend?.urls?.apiV1}${backend?.urls?.accounts}${backend?.urls?.requestAccount}/`,
            headers: {},
            data: {
                id: id,
                languageId: languageId,
                method: backend?.methods?.requestAccounts.getById,
            },
            subMethod: subMethod,
        };
        return await axios.post(requestObj);
    },

    /**
     * Finds an account request by user name (email) and company email.
     * @param {Object} params
     * @param {string} params.userName
     * @param {string} params.email
     * @param {string} params.reCaptchaToken
     * @param {number} params.languageId
     * @param {string} [params.subMethod='']
     * @returns {Promise<objectService>}
     */
    getByUserNameAndEmailAsync: async ({
        userName,
        email,
        reCaptchaToken,
        languageId,
        subMethod = ''
    } = {}) => {
        const requestObj = {
            url: `${backend?.urls?.api}${backend?.urls?.apiV1}${backend?.urls?.accounts}${backend?.urls?.requestAccount}/`,
            headers: {},
            data: {
                userName: userName,
                email: email,
                reCaptchaToken: reCaptchaToken,
                languageId: languageId,
                method: backend?.methods?.requestAccounts.getByUserNameAndEmail,
            },
            subMethod: subMethod,
        };
        return await axios.post(requestObj);
    },
};
